import styled from "styled-components";
import {
  FilledInput,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";

import { useEffect, useMemo } from "react";
import * as yup from "yup";
import { toast } from "react-toastify";
import { settings } from "../../../../helpers/toast.settings";
import { useFormik } from "formik";
import { StyledButton } from "../../../../components/Button/button";
import { addPackage } from "../../../../services/packages/add";
import { ObjectTypesArray } from "../../operator-orders-offering/components/position-add/helpers";
interface PackageAddFormProps {
  storageAreaId: string | undefined;
}
const PackageAddForm = ({ storageAreaId }: PackageAddFormProps) => {
  const PackageAddMutation = useMutation(addPackage, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", {
        toastId: "PackageAddSuccessfully",
        ...settings,
      });
    },
  });
  const validationSchema = yup.object({
    dlugosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga jest wymagana"),
    dlugosc_min: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga min. jest wymagana"),
    dlugosc_max: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga max. jest wymagana"),
    szerokosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga jest wymagana"),
    szerokosc_min: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga min. jest wymagana"),
    szerokosc_max: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga max. jest wymagana"),
    wysokosc: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga jest wymagana"),
    wysokosc_min: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga min. jest wymagana"),
    wysokosc_max: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga max. jest wymagana"),
    waga_min: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga min. jest wymagana"),
    waga_max: yup
      .number()
      .min(1, "Minimalna wartość to 1")
      .typeError("Błędny format!")
      .required("Waga max. jest wymagana"),
  });

  const formik = useFormik({
    initialValues: {
      rodzaj_opakowania: 2,
      dlugosc: 1,
      dlugosc_min: 1,
      dlugosc_max: 1,
      szerokosc: 1,
      szerokosc_min: 1,
      szerokosc_max: 1,
      wysokosc: 1,
      wysokosc_min: 1,
      wysokosc_max: 1,
      waga_min: 1,
      waga_max: 1,
      jednostka_wagi: 0,
      jednostka_dlugosci: 2,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_obszar_skladowania: storageAreaId,
        rodzaj_opakowania: formik.values.rodzaj_opakowania,
        dlugosc: isEurPalete ? formik.values.dlugosc : null,
        dlugosc_min: isEurPalete ? null : formik.values.dlugosc_min,
        dlugosc_max: isEurPalete ? null : formik.values.dlugosc_max,
        szerokosc: isEurPalete ? formik.values.szerokosc : null,
        szerokosc_min: isEurPalete ? null : formik.values.szerokosc_min,
        szerokosc_max: isEurPalete ? null : formik.values.szerokosc_max,
        wysokosc: isEurPalete ? formik.values.wysokosc : null,
        wysokosc_min: isEurPalete ? null : formik.values.wysokosc_min,
        wysokosc_max: isEurPalete ? null : formik.values.wysokosc_max,
        waga_min: formik.values.waga_min,
        waga_max: formik.values.waga_max,
        jednostka_wagi: formik.values.jednostka_wagi,
        jednostka_dlugosci: formik.values.jednostka_dlugosci,
      };

      PackageAddMutation.mutate(body);
    },
  });
  const isEurPalete = useMemo(
    () =>
      formik.values.rodzaj_opakowania === 2 ||
      formik.values.rodzaj_opakowania === 3
        ? true
        : false,
    [formik.values.rodzaj_opakowania]
  );
  return (
    <PackageAddContainer onSubmit={formik.handleSubmit}>
      <>
        <FormControl sx={{ marginTop: "20px" }} fullWidth>
          <InputLabel id="rodzaj_opakowania-label">
            Rodzaj opakowania
          </InputLabel>
          <Select
            placeholder="Rodzaj opakowania"
            labelId="rodzaj_opakowania-label"
            label="rodzaj_opakowania"
            id="rodzaj_opakowania"
            name="rodzaj_opakowania"
            value={formik.values.rodzaj_opakowania}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{ backgroundColor: "white" }}
          >
            {ObjectTypesArray.map((item, index) => (
              <MenuItem value={index}>{item}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {isEurPalete ? (
          <>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="dlugosc"
                name="dlugosc"
                value={formik.values.dlugosc}
                onChange={formik.handleChange}
                error={formik.touched.dlugosc && Boolean(formik.errors.dlugosc)}
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-dlugosc-helper-text"
                inputProps={{
                  "aria-label": "dlugosc",
                }}
              />
              <FormHelperText id="filled-dlugosc-helper-text">
                Długość
              </FormHelperText>
            </FormControl>

            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="szerokosc"
                name="szerokosc"
                value={formik.values.szerokosc}
                onChange={formik.handleChange}
                error={
                  formik.touched.szerokosc && Boolean(formik.errors.szerokosc)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-szerokosc-helper-text"
                inputProps={{
                  "aria-label": "szerokosc",
                }}
              />
              <FormHelperText id="filled-szerokosc-helper-text">
                Szerokość
              </FormHelperText>
            </FormControl>

            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="wysokosc"
                name="wysokosc"
                value={formik.values.wysokosc}
                onChange={formik.handleChange}
                error={
                  formik.touched.wysokosc && Boolean(formik.errors.wysokosc)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-wysokosc-helper-text"
                inputProps={{
                  "aria-label": "wysokosc",
                }}
              />
              <FormHelperText id="filled-wysokosc-helper-text">
                Wysokość
              </FormHelperText>
            </FormControl>
          </>
        ) : (
          <>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="dlugosc_min"
                name="dlugosc_min"
                value={formik.values.dlugosc_min}
                onChange={formik.handleChange}
                error={
                  formik.touched.dlugosc_min &&
                  Boolean(formik.errors.dlugosc_min)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-dlugosc_min-helper-text"
                inputProps={{
                  "aria-label": "dlugosc_min",
                }}
              />
              <FormHelperText id="filled-dlugosc_min-helper-text">
                Długość min.
              </FormHelperText>
            </FormControl>

            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="dlugosc_max"
                name="dlugosc_max"
                value={formik.values.dlugosc_max}
                onChange={formik.handleChange}
                error={
                  formik.touched.dlugosc_max &&
                  Boolean(formik.errors.dlugosc_max)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-dlugosc_max-helper-text"
                inputProps={{
                  "aria-label": "dlugosc_max",
                }}
              />
              <FormHelperText id="filled-dlugosc_max-helper-text">
                Długość max.
              </FormHelperText>
            </FormControl>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="szerokosc_min"
                name="szerokosc_min"
                value={formik.values.szerokosc_min}
                onChange={formik.handleChange}
                error={
                  formik.touched.szerokosc_min &&
                  Boolean(formik.errors.szerokosc_min)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-szerokosc_min-helper-text"
                inputProps={{
                  "aria-label": "szerokosc_min",
                }}
              />
              <FormHelperText id="filled-szerokosc_min-helper-text">
                Szerokość min.
              </FormHelperText>
            </FormControl>

            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="szerokosc_max"
                name="szerokosc_max"
                value={formik.values.szerokosc_max}
                onChange={formik.handleChange}
                error={
                  formik.touched.szerokosc_max &&
                  Boolean(formik.errors.szerokosc_max)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-szerokosc_max-helper-text"
                inputProps={{
                  "aria-label": "szerokosc_max",
                }}
              />
              <FormHelperText id="filled-szerokosc_max-helper-text">
                Szerokość max.
              </FormHelperText>
            </FormControl>
            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="wysokosc_min"
                name="wysokosc_min"
                value={formik.values.wysokosc_min}
                onChange={formik.handleChange}
                error={
                  formik.touched.wysokosc_min &&
                  Boolean(formik.errors.wysokosc_min)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-wysokosc_min-helper-text"
                inputProps={{
                  "aria-label": "wysokosc_min",
                }}
              />
              <FormHelperText id="filled-wysokosc_min-helper-text">
                Wysokość min.
              </FormHelperText>
            </FormControl>

            <FormControl
              sx={{ marginTop: "20px", width: "25ch" }}
              variant="filled"
            >
              <StyledSummaryInput
                id="wysokosc_max"
                name="wysokosc_max"
                value={formik.values.wysokosc_max}
                onChange={formik.handleChange}
                error={
                  formik.touched.wysokosc_max &&
                  Boolean(formik.errors.wysokosc_max)
                }
                onBlur={formik.handleBlur}
                type="number"
                endAdornment={
                  <InputAdornment position="end">mm.</InputAdornment>
                }
                aria-describedby="filled-wysokosc_max-helper-text"
                inputProps={{
                  "aria-label": "wysokosc_max",
                }}
              />
              <FormHelperText id="filled-wysokosc_max-helper-text">
                Wysokość max.
              </FormHelperText>
            </FormControl>
          </>
        )}

        <FormControl sx={{ marginTop: "20px", width: "25ch" }} variant="filled">
          <StyledSummaryInput
            id="waga_min"
            name="waga_min"
            value={formik.values.waga_min}
            onChange={formik.handleChange}
            error={formik.touched.waga_min && Boolean(formik.errors.waga_min)}
            onBlur={formik.handleBlur}
            type="number"
            endAdornment={<InputAdornment position="end">kg.</InputAdornment>}
            aria-describedby="filled-waga_min-helper-text"
            inputProps={{
              "aria-label": "waga_min",
            }}
          />
          <FormHelperText id="filled-waga_min-helper-text">
            Waga min.
          </FormHelperText>
        </FormControl>

        <FormControl sx={{ marginTop: "20px", width: "25ch" }} variant="filled">
          <StyledSummaryInput
            id="waga_max"
            name="waga_max"
            value={formik.values.waga_max}
            onChange={formik.handleChange}
            error={formik.touched.waga_max && Boolean(formik.errors.waga_max)}
            onBlur={formik.handleBlur}
            type="number"
            endAdornment={<InputAdornment position="end">kg.</InputAdornment>}
            aria-describedby="filled-waga_max-helper-text"
            inputProps={{
              "aria-label": "waga_max",
            }}
          />
          <FormHelperText id="filled-waga_max-helper-text">
            Waga max.
          </FormHelperText>
        </FormControl>

        <SubmitButtonWrapper>
          <StyledButton
            disabled={!formik.isValid}
            type="submit"
            variant="contained"
            sx={{ width: "96%" }}
          >
            Zapisz
          </StyledButton>
        </SubmitButtonWrapper>
      </>
    </PackageAddContainer>
  );
};

export default PackageAddForm;

const PackageAddContainer = styled.form`
  width: 50%;
  flex-wrap: wrap;
  gap: 6px;
  @media (max-width: 500px) {
    width: 70%;
  }

  @media (max-width: 1143px) {
    justify-content: center;
  }

  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 3%;
  border-radius: 10px;
`;
const SubmitButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
`;
const StyledSummaryInput = styled(FilledInput)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));
